import React, { useContext, useEffect, useState } from 'react'
import { Content, Title } from 'core/screen-util'
import { connect } from 'react-redux'
import { getApiTargetInfo, getClientInfo } from 'core'
import { downloadFile, sortStringArray } from 'core/utils'
import {
  CPS_CLIENT,
  KINDLE_CLIENT,
  SRP_CLIENT,
  WEE_CLIENT,
  APS_CLIENT,
  PJM_CLIENT,
  AEPREG_CLIENT,
  AEPUNREG_CLIENT,
  MISO_CLIENT,
} from 'client'
import { getGuideMap } from 'api/pgads'
import { ErrorContext } from 'context'
import { NYISO_CLIENT } from '../../client'

const Guide = ({ apiTargetInfo, CLIENT }) => {
  const [guideMap, setGuideMapList] = useState({})
  const { setError } = useContext(ErrorContext)
  useEffect(
    _ => {
      getGuideMap(apiTargetInfo).fork(setError, setGuideMapList)
    },
    [apiTargetInfo, setError]
  )

  const byClientFiles = byClient => {
    return sortStringArray(Object.keys(guideMap))
      .filter(k => k.startsWith(byClient + '-'))

      .map(k => (
        <li key={k}>
          <a
            key={k}
            target="_self"
            onClick={_ =>
              downloadFile(apiTargetInfo)('utils/guide?id=' + k)(
                guideMap[k].substr(guideMap[k].indexOf('=') + 1)
              )
            }
          >
            {guideMap[k].substr(guideMap[k].indexOf('=') + 1)}
            {/* {guideMap[k]
             .substr(k.indexOf('='), guideMap[k].length)} */}
          </a>
        </li>
      ))
  }

  if (CLIENT === NYISO_CLIENT) {
    return (
      <Content style={{ height: '800px', width: '500px' }}>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '25px',
          }}
        >
          Guide
        </Title>
        <div style={{ marginTop: '25px' }}>
          <ol type="1" style={{ marginLeft: '25px' }}>
            {byClientFiles(NYISO_CLIENT)}
          </ol>
        </div>
      </Content>
    )
  }

  return (
    <Content style={{ height: '800px', width: '500px' }}>
      <Title
        style={{
          marginRight: '15px',
          marginBottom: '25px',
        }}
      >
        Guide
      </Title>
      <ol type="1" style={{ marginTop: '25px' }}>
        <li>
          <a
            // href={apiTargetInfo.baseUrl + '/utils/guide?id=manual'}
            target="_self"
            onClick={_ =>
              downloadFile(apiTargetInfo)('utils/guide?id=manual')(
                'PowerGADS 4.0 User Manual.pdf'
              )
            }
          >
            PowerGADS 4.0 User Manual
          </a>
        </li>
        <li>
          <a
            // href={apiTargetInfo.baseUrl + '/utils/guide?id=quick-process-guide'}
            target="_self"
            onClick={_ =>
              downloadFile(apiTargetInfo)('utils/guide?id=quick-process-guide')(
                'PowerGADS 4.0 Quick Process Guide.pdf'
              )
            }
          >
            PowerGADS 4.0 Quick Process Guide
          </a>
        </li>
        {(CLIENT === WEE_CLIENT ||
          CLIENT === CPS_CLIENT ||
          CLIENT === SRP_CLIENT ||
          CLIENT === KINDLE_CLIENT ||
          CLIENT === APS_CLIENT ||
          CLIENT === AEPREG_CLIENT ||
          CLIENT === AEPUNREG_CLIENT) && (
          <li>
            <a
              // href={apiTargetInfo.baseUrl + '/utils/guide?id=quick-process-guide'}
              target="_self"
              onClick={_ =>
                downloadFile(apiTargetInfo)(
                  'utils/guide?id=we-margin-analysis'
                )('Margin Analyzer User Manual.pdf')
              }
            >
              Margin Analyzer User Manual
            </a>
          </li>
        )}

        {CLIENT === PJM_CLIENT && byClientFiles(PJM_CLIENT)}
        {CLIENT === MISO_CLIENT && byClientFiles(MISO_CLIENT)}
        {CLIENT === NYISO_CLIENT && byClientFiles(NYISO_CLIENT)}
      </ol>
    </Content>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  CLIENT: getClientInfo(state),
})

export default connect(mapStateToProps)(Guide)
